export default {
  cartonNumber: 'Carton Number',
  scanDate: 'Scan Date',
  tunnelID: 'Tunnel ID',
  filter: 'Filter',
  rfid: 'EPC',
  productCode: 'Product Code',
  size: 'Size',
  upc: 'UPC',
  productName: 'Product Name',
  purchaseOrder: 'Purchase Order',
  salesOrder: 'Sales Order',
  IB: 'IB',
  IBTitle: 'IB ',
  IBCartonNumber: 'Carton Number',
  IBOriginalCartonNumber: 'Original Carton Number',
  IBASN: 'ASN',
  IBTunnelID: 'Tunnel ID',
  IBLPNSizeType: 'LPN Size Type',
  IBFactoryCode: 'Factory Code',
  IBCarrier: 'Carrier',
  IBItemAttribute: 'Item Attribute',
  IBGRDate: 'GR Date',
  IBScanDate: 'Scan Date',
  OB: 'OB',
  OBTitle: 'OB ',
  OBCartonNumber: 'Carton Number',
  OBDeliveryNoteNo: 'Delivery Note No.',
  OBMajor: 'Major',
  OBTunnelID: 'Tunnel ID',
  OBTaskType: 'Task Type',
  OBSOType: 'SO Type',
  OBCarrier: 'Carrier',
  OBRetag: 'Retag',
  OBShipFrom: 'Ship From',
  OBShipTo: 'Ship To',
  OBStore: 'Store',
  OBItemAttribute: 'Item Attribute',
  OBTrailerNumber: 'Trailer Number',
  OBCartonNetWeight: 'Carton Net Weight',
  OBCartonGrossWeight: 'Carton Gross Weight',
  OBGIDate: 'GI Date',
  OBScanDate: 'Scan Date',
  deliveryNo: 'Delivery No.',
  cartonNo: 'Carton No.',
  qty: 'Qty',
  shipfrom: 'Ship From',
  shipto: 'Ship To',
  store: 'Store',
  retag: 'Retag',
  createDate: 'Create Date',
  updateDate: 'Update Date',
  downloadLifecycle: 'Download Lifecycle Details',
  rfidHistory: 'RFID History',
  operation: 'Operation',
  operator: 'Operator',
  rso: 'RSO',
  returnValidation: 'Return Validation',
  originalCartonNumber: 'Original Carton Number'
}
